import { render, staticRenderFns } from "./productWeb.vue?vue&type=template&id=6f1704f3&scoped=true"
import script from "./productWeb.vue?vue&type=script&lang=js"
export * from "./productWeb.vue?vue&type=script&lang=js"
import style0 from "./productWeb.vue?vue&type=style&index=0&id=6f1704f3&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1704f3",
  null
  
)

export default component.exports